// extracted by mini-css-extract-plugin
export var borderRadius = "_9a-4";
export var large = "_9a-3";
export var logoContainer = "_9a-0";
export var nameLogo = "_9a-2";
export var small = "_9a-1";